const docType = (documents: Array<TDocument>, editing: string): string | undefined =>
  documents && editing ? documents.find((d: TDocument) => d._id === editing)?._type || undefined : undefined;

export const filterDocs = (type: string, documents: TDocument[]): TDocument[] =>
  documents ? documents.filter(d => d._type === type) : [];

export type TDocument =
  | ISleepPolygraphy
  | ISleepStudy
  | ISpirometry
  | INightOximetry
  | ICarbonDioxideMeasurement
  // For MADtherapy question in sleep polygraphy
  | IMADTherapy
  // For filtering shown tests for specific diagnosis
  | IDiagnosis
  | IDiagnosticExamination; // General docType for different CNP examinations

export const getHeaderId = (
  documents: Array<TDocument>,
  editing?: string,
  viewing?: string,
  diagnosticExamKey?: TDiagnosticExamKeys,
  platform?: Platform,
): string => {
  if (!editing && !viewing) return 'clpAndCnpTests.title';
  if (platform === 'mgravis') {
    if (docType(documents, editing ?? viewing ?? '') === 'diagnosticExamination' && diagnosticExamKey) {
      return `clpAndCnpTests.mgravis.${diagnosticExamCodes[diagnosticExamKey]?.code}`;
    }
    return 'clpAndCnpTests.mgravis.title';
  }
  return docType(documents, editing ?? viewing ?? '') === 'sleepPolygraphy'
    ? 'clpAndCnpTests.sleepPolygraphy'
    : docType(documents, editing ?? viewing ?? '') === 'sleepStudy'
      ? 'clpAndCnpTests.sleepStudy'
      : docType(documents, editing ?? viewing ?? '') === 'spirometry'
        ? 'clpAndCnpTests.spirometry'
        : docType(documents, editing ?? viewing ?? '') === 'nightOximetry'
          ? 'clpAndCnpTests.nightOximetry'
          : docType(documents, editing ?? viewing ?? '') === 'carbonDioxideMeasurement'
            ? 'clpAndCnpTests.carbonDioxideMeasurement'
            : 'clpAndCnpTests.title';
};

export const diagnosticExamCodes: Partial<Record<TDiagnosticExamKeys, ICode>> = {
  enmg: {
    codeSystem: 'THL - Toimenpideluokitus',
    code: 'XA402',
    display: 'ENMG',
  },
  repeatedNerveStimulation: {
    codeSystem: 'http://snomed.info/sct',
    code: '252748005',
    display: 'Toistostimulaatio',
  },
  singleFiberEMG: {
    codeSystem: 'http://snomed.info/sct',
    code: '252756008',
    display: 'Yksisyy-EMG',
  },
};
